(function () {
  const headerSelector = '[data-site-header]';
  const bundleSelector = '[data-atc-bundle]';
  const bundleListSelector = '[data-atc-bundle-list]';

  function resetBundle(container, list) {
    console.debug('[ATC Bundle] reset bundle container', { hasContainer: !!container, hasList: !!list });
    list.innerHTML = '';
    container.setAttribute('hidden', 'hidden');
  }

  function renderEntryList(list, entries) {
    if (!entries.length) {
      console.debug('[ATC Bundle] renderEntryList: no visible entries');
      return false;
    }
    const item = document.createElement('li');
    item.className = 'cart-item-bundle__item ct-cart-item';

    entries.forEach(([key, value]) => {
      const wrapper = document.createElement('span');
      wrapper.className = 'cart-item-bundle__item-title';

      const dt = document.createElement('dt');
      dt.className = 'cart-item-product-options__option-key';
      dt.textContent = `${key}:`;

      const dd = document.createElement('dd');
      dd.className = 'cart-item-product-options__option-value';
      dd.textContent = value;

      wrapper.appendChild(dt);
      wrapper.appendChild(dd);
      item.appendChild(wrapper);
    });

    if (item.children.length) {
      list.appendChild(item);
      return true;
    }
    return false;
  }

  function getVisibleEntriesFromProperties(properties) {
    if (!properties) {
      return [];
    }

    return Object.entries(properties).filter(([key, value]) => {
      return key && !key.startsWith('_') && value !== null && value !== '';
    });
  }

  function findBundleElements() {
    const header = document.querySelector(headerSelector);
    if (!header) {
      console.debug('[ATC Bundle] header not found');
      return { container: null, list: null };
    }
    const container = header.querySelector(bundleSelector);
    if (!container) {
      console.debug('[ATC Bundle] bundle container not found inside header yet');
      return { container: null, list: null };
    }

    const list = container.querySelector(bundleListSelector);
    if (!list) {
      console.debug('[ATC Bundle] bundle list element missing inside container');
    }
    return { container, list };
  }

  function waitForBundleElements(timeout = 1000) {
    return new Promise((resolve) => {
      const header = document.querySelector(headerSelector);
      if (!header) {
        console.debug('[ATC Bundle] no header found while waiting for bundle elements');
        resolve({ container: null, list: null });
        return;
      }

      let observer;
      let timer;

      const cleanup = () => {
        if (observer) {
          observer.disconnect();
        }
        if (timer) {
          clearTimeout(timer);
        }
      };

      const attempt = () => {
        const elements = findBundleElements();
        if (elements.container && elements.list) {
          cleanup();
          console.debug('[ATC Bundle] bundle elements ready');
          resolve(elements);
        }
      };

      attempt();

      if (header && (!findBundleElements().container || !findBundleElements().list)) {
        observer = new MutationObserver(() => {
          attempt();
        });
        observer.observe(header, { childList: true, subtree: true });

        timer = setTimeout(() => {
          cleanup();
          console.warn('[ATC Bundle] bundle elements not found before timeout');
          resolve({ container: null, list: null });
        }, timeout);
      }
    });
  }

  async function populateFlyoutBundle(event) {
    console.debug('[ATC Bundle] populateFlyoutBundle triggered', event);
    const { container, list } = await waitForBundleElements();
    if (!container || !list) {
      console.warn('[ATC Bundle] bundle container/list missing, abort rendering');
      return;
    }

    resetBundle(container, list);

    const responseItem = event?.detail?.responseData;
    if (!responseItem || !responseItem.id) {
      console.debug('[ATC Bundle] no response item id found');
      return;
    }

    try {
      const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
      if (!cartResponse.ok) {
        console.error('[ATC Bundle] cart fetch failed', cartResponse.status, cartResponse.statusText);
        return;
      }
      const cartData = await cartResponse.json();
      console.debug('[ATC Bundle] cart data loaded', cartData);
      const lineItem = (cartData.items || []).find((item) => item.id === responseItem.id);

      if (!lineItem) {
        console.debug('[ATC Bundle] line item not found in cart data');
        return;
      }

      let rendered = false;

      const propertyEntries = getVisibleEntriesFromProperties(lineItem.properties);
      if (propertyEntries.length) {
        console.debug('[ATC Bundle] rendering from line item properties', propertyEntries);
        rendered = renderEntryList(list, propertyEntries) || rendered;
      }

      if (!rendered && Array.isArray(lineItem.item_components)) {
        console.debug('[ATC Bundle] fallback to item_components');
        lineItem.item_components.forEach((component) => {
          const componentEntries = getVisibleEntriesFromProperties(component && component.properties);
          if (componentEntries.length) {
            const didRender = renderEntryList(list, componentEntries);
            rendered = rendered || didRender;
          }
        });
      }

      if (rendered && list.children.length) {
        console.debug('[ATC Bundle] bundle list populated, showing container');
        container.removeAttribute('hidden');
      } else {
        console.debug('[ATC Bundle] nothing rendered for bundle list');
      }
    } catch (error) {
      console.error('Bundle rendering failed:', error);
    }
  }

  document.addEventListener('addToCartFlyout:complete', populateFlyoutBundle);
  document.addEventListener('closeFlyouts', () => {
    const { container, list } = findBundleElements();
    if (container && list) {
      console.debug('[ATC Bundle] closeFlyouts reset');
      resetBundle(container, list);
    }
  });
})();

